<template>
  <section :class="theme" class="hero">
    <div class="hero-body">
      <div class="container has-text-centered">
        <p class="splash-1 splash-title">wouldn't it be awesome to</p>
        <div class="splash-2">
          <img
            class="splash-img"
            style="height: 400px"
            src="../assets/home.svg"
            alt="Home"
          />
        </div>
        <p class="splash-3 splash-title">
          have a <span class="highlight">stress free</span> IT?
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import ScrollReveal from "scrollreveal";
export default {
  name: "Banner",
  components: {},
  data: function () {
    return {
      theme: "has-background-grey-lighter",
    };
  },
  created() {},
  methods: {},
  mounted() {
    const sr = ScrollReveal({
      duration: 800,
      delay: 200,
      origin: "top",
      mobile: false,
    });
    sr.reveal(".splash-1", { delay: 200 }, 200);
    sr.reveal(".splash-2", { delay: 800 }, 200);
    sr.reveal(".splash-3", { delay: 1400 }, 200);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Asap+Condensed&display=swap");
.splash-title {
  font-family: "Asap Condensed", sans-serif;
  font-size: calc(40px + (78 - 60) * ((100vw - 300px) / (1600 - 300)));
}
.highlight {
  color: #564fcc;
  border: 2px;
  border-radius: 2px;
}
</style>
